/**
 * Analytics-Reports API-Client (Spec 429 Increment D).
 *
 * Ruft den Mint-Endpunkt `GET /v1/admin/reports/embed-url?reportKey=...` auf, der eine
 * kurzlebige QuickSight-Embed-URL zurueckgibt. Der Endpunkt ist dev/testing-pilot-gegated;
 * auf staging/prod (und solange die Dashboard-IDs noch nicht im SSM-Baum stehen) antwortet
 * er 503 → das Frontend zeigt dann einen „noch nicht verfuegbar"-Zustand.
 */
import { apiClient } from './client';

/** reportKey-Katalog (Contract §2; spiegelt src/types/quicksight-reports.ts). */
export const REPORT_KEYS = [
  'kpi-overview-platform',
  'overview-platform',
  'overview-merchant',
] as const;
export type ReportKey = (typeof REPORT_KEYS)[number];

/** Zielgruppe je reportKey (Contract §2.4). */
export const REPORT_AUDIENCE: Readonly<Record<ReportKey, 'platform' | 'merchant'>> = {
  'kpi-overview-platform': 'platform',
  'overview-platform': 'platform',
  'overview-merchant': 'merchant',
};

/** Antwort des Mint-Endpunkts (0192-D §4b). */
export interface EmbedUrlResponse {
  reportKey: ReportKey;
  embedUrl: string;
  /** Einloese-Fenster der Embed-URL (~5 Min, Single-Use) — NICHT die Session-Dauer. */
  expiresAt: string;
  dataAsOf: string;
  completeness: 'provisional' | 'final';
}

/**
 * Mintet eine Embed-URL fuer genau einen reportKey.
 *
 * `noRetry`: der Endpunkt liefert 503 fuer die ERWARTETEN Pilot-Zustaende (staging/prod dunkel;
 * dashboardId noch nicht im SSM). 503 steht in der Retry-Allowlist des apiClient → ohne noRetry
 * wuerde jeder Seitenaufruf 4× minten (~7 s Backoff), bevor der „wird vorbereitet"-Zustand greift.
 * Der Hook (use-report-embed) unterdrueckt den React-Query-Retry — der noRetry hier schaltet den
 * darunterliegenden Client-Retry ab, sonst laeuft er trotzdem.
 */
export async function fetchReportEmbedUrl(reportKey: ReportKey): Promise<EmbedUrlResponse> {
  // Endpunkt OHNE /v1-Praefix — das /v1 kommt aus API_BASE_URL (constants.ts), sonst baut der
  // apiClient den doppelten Pfad /v1/v1/... (matcht keine API-GW-Behavior → landet bei S3 → 403).
  return apiClient<EmbedUrlResponse>('/admin/reports/embed-url', {
    method: 'GET',
    params: { reportKey },
    noRetry: true,
  });
}
